import { createConsoleLogger } from './baseLogger';
export let logger = createConsoleLogger();
export function setLogger(newLogger) {
    logger = newLogger;
}
/**
 * A logger wrapper to always include some meta base data to the log
 *
 * @param metaBase - The meta data which will always be included into the log
 */
export const createModuleLogger = (metaBase) => {
    return Object.keys(logger).reduce((log, key) => {
        const k = key;
        log[k] = (meta, msg) => {
            if (typeof meta === 'string') {
                return logger[k](metaBase, meta);
            }
            if (typeof meta === 'object') {
                return logger[k]({ ...meta, meta: metaBase }, msg);
            }
            return logger[k]({ meta: metaBase, context: meta }, msg);
        };
        return log;
    }, {});
};
//# sourceMappingURL=logger.js.map